import React, { useState, useEffect } from 'react';
import Modal, { FormField, FormInput, FormButton } from './Modal';
import { authAPI } from '../lib/api';
import { toast } from '../lib/toast';

export default function ChangePasswordModal({ isOpen, onClose }) {
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) { setForm({ current: '', next: '', confirm: '' }); setError(''); }
  }, [isOpen]);

  const upd = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 8) { setError('Le nouveau mot de passe doit faire au moins 8 caractères.'); return; }
    if (form.next !== form.confirm) { setError('La confirmation ne correspond pas.'); return; }
    setLoading(true); setError('');
    try {
      const res = await authAPI.changePassword(form.current, form.next);
      // Le serveur invalide les AUTRES sessions (token_version) et renvoie un token frais
      // pour garder celle-ci active.
      if (res?.data?.token) localStorage.setItem('mlx_token', res.data.token);
      toast.success('Mot de passe modifié — vos autres sessions ont été déconnectées.');
      onClose();
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur lors du changement de mot de passe');
    }
    setLoading(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Changer mon mot de passe" maxWidth="440px">
      <form onSubmit={submit}>
        {error && <div className="mb-4 px-3 py-2 rounded-[8px] text-[12px] text-[#DC2626]" style={{ background: 'rgba(220,38,38,0.1)' }}>{error}</div>}
        <FormField label="Mot de passe actuel" required>
          <FormInput type="password" value={form.current} onChange={(e) => upd('current', e.target.value)} required />
        </FormField>
        <FormField label="Nouveau mot de passe" required>
          <FormInput type="password" value={form.next} onChange={(e) => upd('next', e.target.value)} placeholder="Au moins 8 caractères" required />
        </FormField>
        <FormField label="Confirmer le nouveau mot de passe" required>
          <FormInput type="password" value={form.confirm} onChange={(e) => upd('confirm', e.target.value)} required />
        </FormField>
        <div className="flex justify-end gap-3 mt-6 pt-4 border-t" style={{ borderColor: 'var(--border-color)' }}>
          <FormButton variant="secondary" onClick={onClose}>Annuler</FormButton>
          <FormButton type="submit" disabled={loading}>{loading ? 'Modification...' : 'Modifier'}</FormButton>
        </div>
      </form>
    </Modal>
  );
}
